import React, { useEffect } from "react";
import "./App.css";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useParams,
} from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useCookies } from "react-cookie";
import { useMediaQuery } from "react-responsive";
import axios from "axios";

import { Context as PortalContext } from "./context/portal.context.js";
import { Context as AuthContext } from "./context/auth.context.js";

import Home from "./pages/Home";
import NotAutorized from "./pages/NotAuthorized";
import { CircularProgress } from "@material-ui/core";

import "../src/styles/styles.scss";

const qs = require("qs");

let invoicePaid = false;

const App = () => {
  const { state, hydratePortal } = React.useContext(PortalContext);
  const { getSession, checkSession, getExternalProviderTransactions } =
    React.useContext(AuthContext);

  const authState = React.useContext(AuthContext);

  let history = useHistory();

  const theme = createMuiTheme({
    palette: {
      primary: {
        //main: '#84BD00',
        //main: '#1F2032',
        //main: '#163065',
        main: state.barColor,
        //main: '#000',
        //main: '#1C9BDD',
      },
      secondary: {
        //main: '#88B450',
        main: state.buttonColor,
        //main: '#1C9BDD',
        //main: '#163065',
      },
      welcomeBar: {
        left: "",
        //right: '#1C9BDD',
        //right: '#1F2032',
        //right: '#163065',
        right: "#0078A3",
      },
      amountDue: {
        //main: '#1C9BDD',
        //main: '#163065',
        main: "#004786",
        //main: 'white',
        text: "white",
        border: "1px solid #ddd",
      },
      error: {
        main: "#B00020",
      },
    },
    status: {
      danger: "orange",
    },
    overrides: {
      MuiOutlinedInput: {
        notchedOutline: {
          borderColor: "rgb(211,220,224)",
        },
      },
    },
  });

  useEffect(() => {
    window.addEventListener("message", (message) => {
      receiveMessage(message);
    });

    let op = "";
    let glcode = null;
    const pathArray = window.location.pathname.split("/");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("glcode")) {
      glcode = urlParams.get("glcode");
    }
    if (pathArray) {
      op = pathArray[2];
    }

    hydratePortal({ op, glcode, getSession, history, queryString });

    //getSession({ history });
    setTimeout(function checkSesh() {
      checkSession({ history, op, queryString });
      window.sessionCheck = setTimeout(checkSesh, 16 * 60 * 1000);
    }, 16 * 60 * 1000);
  }, []);

  const xLang = (string) => {
		return string
	}

  const receiveMessage = (message) => {
    if (message.data.operation === "approval") {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;

      invoicePaid = true;
      //getInvoices();

      // refreshLightbox({
      //   buttonColor: theme.palette.secondary.main,
      //   customerID: authState.state.customerID,
      //   merchantID: authState.state.merchantID,
      //   enpartialpayment: state.state.allowPartialPayment,
      // });
    } else if (message.data.operation === "closemodal") {
      //window.location.reload();
      // getLightbox({ buttonColor: props.theme.palette.secondary.main });

      if (invoicePaid) {
        refreshLightbox({
          buttonColor: theme.palette.secondary.main,
          customerID: authState.state.customerID,
          merchantID: authState.state.merchantID,
          enpartialpayment: state.allowPartialPayment,
        });
      }

      //alert(document.body.style.backgroundColor);

      //document.body.style.backgroundColor = "pink";
    } else if (message.data.operation === "isready") {
      let body = document.body;

      //Restore the merchants original style - lightbox is now closed
      if (window.intellipay.bodysave) {
        body.style = window.intellipay.bodysave;
        body.style.margin = "0";
      } else {
        body.style.position = "relative";
        body.style.overflow = "auto";
      }
      //   console.log("Body", window.intellipay.bodysave);
      //   var vp = document.querySelector("meta[name=viewport]");
      //   if (vp) {
      //     if (window.intellipay.viewportsave) {
      //       vp.setAttribute("content", window.intellipay.viewportsave);
      //     } else {
      //       vp.setAttribute("content", "");
      //     }
      //   }
    }
  };

  const refreshLightbox = async ({
    buttonColor,
    customerID,
    merchantID,
    enpartialpayment,
  }) => {
    // setSelected([]);
    // setPaymentTotal(0.0);

    const options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        merchantID,
        customerID,
        method: "refreshLightbox",
        params: `{merchantID: ${merchantID}}`,
      }),
      withCredentials: true,
    };

    const intellipayResponse = await axios(options);
    eval(intellipayResponse.data.lightbox);
    window.intellipay.auth.enpartialpayment = enpartialpayment;
    window.intellipay.auth.isFullAccount = authState.state.isFullAccount;
    window.intellipay.auth.isCustPortal = true;
    window.intellipay.enable("email");

    invoicePaid = false;

    let op = "";
    const pathArray = window.location.pathname.split("/");
    if (pathArray) {
      op = pathArray[2];
    }
    

    if(pathArray && pathArray[3] == 'deals'){
      history.push(`/${op}/deals`);
    } else {
      history.push(`/${op}/invoices`);
    }
    
    //getInvoices();

    //intellipayResponse.data.lightbox;

    //window.intellipay = null;

    //window.intellipay = intellipayResponse.data.lightbox;
  };

  if (state.loading) {
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgb(247, 248, 249)",
        }}
      >
        <CircularProgress />
      </div>
    );
  } else {
    if (state.opError) {
      return <NotAutorized />;
    } else {
      return (
        <MuiThemeProvider theme={theme}>
          <div style={{ backgroundColor: "rgb(247, 248, 249)" }}>
            <Switch>
              <Route path="/:op">
                <Home theme={theme} />
              </Route>

              {/* <Route path="*">
                <NoMatch />
              </Route> */}
            </Switch>
          </div>
        </MuiThemeProvider>
      );
    }
  }
};

export default App;
